module.exports = __webpack_public_path__ + "img/angle-bottom.4bb8a977.svg";